import { FaPlay, FaDesktop, FaMobileAlt } from 'react-icons/fa';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './tutorial.css';

const TutorialLibrary = () => {
    
  // Mobile App Tutorials (SFA & MFA)
  const mobileTutorials = {
    "Mobile App - Sales Force Automation (SFA)": [
      {
        id: 23,
        title: "Van Seller App",
        url: "https://swdmssaprod.blob.core.windows.net/training/MobileApp/App_Van_Seller.mp4",
        description: "Mobile app for van sellers - sales on the go",
        platform: "mobile"
      },
      {
        id: 24,
        title: "Pre-Seller App",
        url: "https://swdmssaprod.blob.core.windows.net/training/MobileApp/App_Pre_Seller.mp4",
        description: "Pre-sales activities and customer engagement",
        platform: "mobile"
      },
      {
        id: 25,
        title: "Merchandizing App Intro",
        url: "https://swdmssaprod.blob.core.windows.net/training/MobileApp/App_Merchandizing_1.mp4",
        description: "Introduction to merchandizing operations on mobile",
        platform: "mobile"
      },
      {
        id: 26,
        title: "Merchandizing App Continued",
        url: "https://swdmssaprod.blob.core.windows.net/training/MobileApp/App_Merchandizing_2.mp4",
        description: "Continued merchandizing features on mobile",
        platform: "mobile"
      }
    ]
  };

  // DMS (Web App) Tutorials - listed from bottom to top
  const dmsTutorials = {
    "Dashboard & Analytics": [
      {
        id: 1,
        title: "Login",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Login.mp4",
        description: "How to access the SellWise360 system",
        platform: "web"
      },
      {
        id: 2,
        title: "Sales Dashboard",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Sales_Dashboard.mp4",
        description: "Overview of sales performance metrics",
        platform: "web"
      },
      {
        id: 3,
        title: "Sales Rep & Warehouse Performance",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/SaleRep_Warehouse_Performance.mp4",
        description: "Track performance of sales reps and warehouses",
        platform: "web"
      },
      {
        id: 4,
        title: "Merchandizing Dashboard",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Merchandizing_Dashboard.mp4",
        description: "Monitor merchandizing activities and results",
        platform: "web"
      }
    ],
    "Inventory Management": [
      {
        id: 5,
        title: "Stock Replenishment",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Stock_Replenishment.mp4",
        description: "Basic stock replenishment procedures",
        platform: "web"
      },
      {
        id: 6,
        title: "Stock Return",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Stock_Return.mp4",
        description: "Process stock returns from customers",
        platform: "web"
      },
      {
        id: 7,
        title: "Stock Adjustment",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Stock_Adjustment.mp4",
        description: "Adjust stock levels and correct discrepancies",
        platform: "web"
      },
      {
        id: 8,
        title: "Route Stock Replenishment",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Route_Stock_Replenishment.mp4",
        description: "Replenish stock based on route requirements",
        platform: "web"
      },
      {
        id: 9,
        title: "Stock Transfer",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Stock_Transfer.mp4",
        description: "Transfer stock between warehouses/locations",
        platform: "web"
      },
      {
        id: 10,
        title: "Stockout Management",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Stockout.mp4",
        description: "Handle and report stockout situations",
        platform: "web"
      }
    ],
    "Sales Operations": [
      {
        id: 11,
        title: "Discount & Promotion",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Discount_Promotion.mp4",
        description: "Configure discounts and promotional offers",
        platform: "web"
      },
      {
        id: 12,
        title: "Sales Ordering Intro",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Sales_ordering_1.mp4",
        description: "Introduction to sales order creation process",
        platform: "web"
      },
      {
        id: 13,
        title: "Sales Ordering Continued",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Sale_Ordering_2.mp4",
        description: "Continued sales order processing",
        platform: "web"
      },
      {
        id: 14,
        title: "Non-Sales Visit",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Non_Sales_Visit.mp4",
        description: "Recording customer visits without sales",
        platform: "web"
      }
    ],
    "Merchandizing Operations": [
      {
        id: 15,
        title: "Merchandizing Intro",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Merchandizing_1.mp4",
        description: "Introduction to merchandizing operations",
        platform: "web"
      },
      {
        id: 16,
        title: "Merchandizing Continued (A)",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Merchandizing_2.mp4",
        description: "Continued merchandizing activities",
        platform: "web"
      },
      {
        id: 17,
        title: "Merchandizing Continued (B)",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Merchandizing_3.mp4",
        description: "Continued merchandizing techniques",
        platform: "web"
      }
    ],
    "Master Data & Setup": [
      {
        id: 18,
        title: "Route & Sales Rep Management",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Route_Sales_Rep.mp4",
        description: "Configure sales routes and manage sales representatives",
        platform: "web"
      },
      {
        id: 19,
        title: "Product Management",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Product.mp4",
        description: "Manage product catalog, pricing, and inventory",
        platform: "web"
      },
      {
        id: 20,
        title: "Customer Management",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Customer.mp4",
        description: "Create and manage customer profiles and accounts",
        platform: "web"
      }
    ],
    "Reporting": [
      {
        id: 21,
        title: "Sales Report Intro",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Report_Sales_1.mp4",
        description: "Introduction to sales reporting and analysis",
        platform: "web"
      },
      {
        id: 22,
        title: "Sales Report Continued",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Report_Sales_2.mp4",
        description: "Continued sales reporting with filters",
        platform: "web"
      },
      {
        id: 23,
        title: "Balance Report",
        url: "https://swdmssaprod.blob.core.windows.net/training/DMS/Report_Balance.mp4",
        description: "Generate and analyze balance reports",
        platform: "web"
      }
    ]
  };

  const VideoCard = ({ video }) => {
    const handleVideoClick = () => {
      window.open(video.url, '_blank', 'noopener,noreferrer');
    };

    return (
      <div className="video-card" onClick={handleVideoClick}>
        <div className="video-header">
          <div className="platform-indicator">
            {video.platform === 'web' ? <FaDesktop /> : <FaMobileAlt />}
            <span>{video.platform === 'web' ? 'Web' : 'Mobile'}</span>
          </div>
          <div className="play-button">
            <FaPlay />
          </div>
        </div>
        <div className="video-content">
          <h4>{video.title}</h4>
          <p>{video.description}</p>
          <div className="video-url">
            <small>Click to open video</small>
          </div>
        </div>
      </div>
    );
  };

  return (
      <div className="privacy-policy"> <Header />
       <br/><br/>
        <div className="container">
          <header className="privacy-header">
            <h1>Tutorial Library</h1>
          </header>

          
    <section>
      <div className="container">
       

        {/* Mobile App Section */}
        <div className="tutorial-section">
          <h3 className="section-subtitle">
            <FaMobileAlt className="section-icon" /> Mobile Applications
          </h3>
          {Object.entries(mobileTutorials).map(([category, videos]) => (
            <div key={category} className="tutorial-category">
              <h4>{category}</h4>
              <div className="video-grid">
                {videos.map(video => (
                  <VideoCard key={video.id} video={video} />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* DMS Web App Section */}
        <div className="tutorial-section">
          <h3 className="section-subtitle">
            <FaDesktop className="section-icon" /> Distributor Management System (Web)
          </h3>
          {Object.entries(dmsTutorials).map(([category, videos]) => (
            <div key={category} className="tutorial-category">
              <h4>{category}</h4>
              <div className="video-grid">
                {videos.map(video => (
                  <VideoCard key={video.id} video={video} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      
    </section>
            </div><Footer />
      </div>
  );
};

export default TutorialLibrary;